import { render, staticRenderFns } from "./suspendedEmployees.vue?vue&type=template&id=08e39c9c&scoped=true"
import script from "./suspendedEmployees.vue?vue&type=script&lang=js"
export * from "./suspendedEmployees.vue?vue&type=script&lang=js"
import style0 from "./suspendedEmployees.vue?vue&type=style&index=0&id=08e39c9c&prod&lang=scss&scoped=true"
import style1 from "./suspendedEmployees.vue?vue&type=style&index=1&id=08e39c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e39c9c",
  null
  
)

export default component.exports